const gregorianFr = {
    name: 'gregorian_fr',
    months: [
        ['Janvier', 'Janv'],
        ['Février', 'Févr'],
        ['Mars', 'Mars'],
        ['Avril', 'Avr'],
        ['Mai', 'Mai'],
        ['Juin', 'Juin'],
        ['Juillet', 'Juill'],
        ['Août', 'Août'],
        ['Septembre', 'Sept'],
        ['Octobre', 'Oct'],
        ['Novembre', 'Nov'],
        ['Décembre', 'Déc'],
    ],
    weekDays: [
        ['Dimanche', 'Dim'],
        ['Lundi', 'Lun'],
        ['Mardi', 'Mar'],
        ['Mercredi', 'Mer'],
        ['Jeudi', 'Jeu'],
        ['Vendredi', 'Vend'],
        ['Samedi', 'Sam'],
    ],
    digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    meridiems: [
        ['Matin', 'M'],
        ['Apès-midi', 'AP'],
    ],
};

export default gregorianFr;
